import { css } from '@emotion/react';

export const registrationFormCss = css`
    display: flex;
    min-width: 1200px;
    flex-direction: column;
    background-color: #f5f5f5;
    border-radius: 10px;
    max-width: 1440px;
    margin: 0 auto;
    width: 1200px;
    padding: 120px 0px;
    align-items: flex-start;
    gap: 60px;

    h1 {
        margin-bottom: 20px;
    }

    form {
        display: flex;
        flex-direction: column;
        width: 100%;

        label {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;

            input, textarea, select {
                padding: 10px;
                border: 1px solid #ccc;
                border-radius: 5px;
                margin-top: 5px;
            }

            button {
                margin-top: 5px;
                padding: 10px;
                background-color: #007BFF;
                color: white;
                border: none;
                border-radius: 5px;
                cursor: pointer;

                &:hover {
                    background-color: #0056b3;
                }
            }
        }

        button[type="submit"], button[type="button"] {
            margin-top: 10px;
            padding: 10px;
            background-color: #007BFF;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;

            &:hover {
                background-color: #0056b3;
            }
        }
    }
`;

export const modalCss = css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;

    .modal-content {
        background-color: white;
        padding: 20px;
        border-radius: 5px;
        text-align: center;
    }

    button {
        padding: 10px;
        background-color: #007BFF;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;

        &:hover {
            background-color: #0056b3;
        }
    }
`;

export const buttonCss = css`
    padding: 10px;
    background-color: #007BFF;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }
`;

export const inputFileCss = css`
    display: none;
`;

export const previewImgCss = css`
    position: relative;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 10px;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;


export const addAuthorWidthCss = css`
    margin: 0 auto;
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    max-width: 1200px;
    padding: 120px 0px;
    align-items: flex-start;
    gap: 60px;

    @media (max-width: 768px) {
        padding: 0 20px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }
    
`;

export const formCss = css`
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
`;


export const formInputCss = css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap:30px;
    
    .title {
        color : #1E1E1E;
        font-size: 24px;
        font-weight: 700;
        
        @media (max-width: 640px) {
            font-size: 18px;
        }
    }
    .point {
        color: #19CF7A;
        font-weight: 700;
    }
    
    .subTitle {
        font-size: 24px;
        color:#1E1E1E;
        font-weight: 600;
        margin-bottom: 4px;
        
        @media (max-width: 640px) {
            font-size: 18px;
        }
    }
`;

export const titleCss = css`
    width: 100%;
    display: flex;
    justify-content: flex-start;
`;
